import type { FooterTemplate } from '@iheartjane/data-access';
import { Card, Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';

import { MaxCharacterHelper } from '../MaxCharacterHelper';
import { PremiumLinks } from '../PremiumLinks';

import styles from './Footer.module.css';

const SOCIAL_LINK_LABEL_OPTIONS = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'X', value: 'x' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'Spotify', value: 'spotify' },
  { label: 'Google', value: 'google' },
  { label: 'Yelp', value: 'yelp' },
];

export const SocialMediaSection = () => {
  const formMethods = useFormContext<FooterTemplate>();
  const socialLinks = formMethods.watch('social_links');

  const hasLabelOrLinks =
    socialLinks?.label || (socialLinks?.links?.length || 0) > 0;

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="social_links"
    >
      <Flex flexDirection="column" gap={16} p={40}>
        <Typography variant="h2-semibold">Social media</Typography>
        <Typography>
          Add links to your social media profiles. Leave this section blank if
          you don't want social media in your footer.
        </Typography>

        {hasLabelOrLinks && (
          <Form.TextField
            label="Header"
            name="social_links.label"
            mb={8}
            placeholder="Add header (optional)"
            helperText={
              <MaxCharacterHelper
                maxLength={20}
                value={formMethods.watch('social_links.label') ?? ''}
              />
            }
          />
        )}

        <PremiumLinks
          addButtonLabel="Add social media"
          controlName="social_links.links"
          formMethods={formMethods}
          labelOptions={SOCIAL_LINK_LABEL_OPTIONS}
          maxDepth={0}
        />
      </Flex>
    </Card>
  );
};
